import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/barlow-semi-condensed/500.css';
import '@fontsource/barlow-semi-condensed/600.css';
// Brand tokens first (SMH Global shared foundation, then Buildiary Site Bronze), then fonts and the app styles.
import '../../../brand/smh-base.css';
import '../../../brand/buildiary.css';
import './styles/fonts.css';
import './styles/app.css';
import App from './App';

async function start() {
  if (import.meta.env.VITE_MOCK === '1') {
    const { installMock } = await import('./mock');
    installMock();
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
void start();
